module.exports = __webpack_public_path__ + "static/media/blueberry.ab32ebdd.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/blueberry.png
// module id = 30
// module chunks = 0